// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_15lF_b058ghGNAuNXV-koh","gridWrapper":"_1iA-nIsDuTfgVtEH5oqv8N","header":"n717ljvogwkREjbtC9zD0","innerRow":"_1HLEJTayycYdandjycobex"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollapsibleGrid/CollapsibleGrid.scss
// module id = 1565
// module chunks = 0